
export default {
    props: {
        isOpen: {
            type: Boolean,
        },
        isClose: {
            type: Function,
        },
        isOk: {
            type: Function,
        },
        startTime: {
            type: String,
        }
    },
    data() {
        return {
            datepicker: false,
            dates: [],
            dateParams: [],
        }
    },
    watch: {
        isOpen(value) {
            console.log(value)
        },
        dateParams(val) {
            this.$emit("sendStartTime", val);
        },
    },
    methods: {


    },
    computed: {
        dateRangeText() {
            let startTime = this.dates[0] > this.dates[1] ? this.dates[1] : this.dates[0]
            let endTime = this.dates[0] > this.dates[1] ? this.dates[0] : this.dates[1]
            this.dateParams = {
                startTime: startTime,
                endTime: endTime,
            }
            return this.dates.join(' ~ ')
        },
    },
}